//const _import = require('./_import_' + process.env.NODE_ENV);

const Routers = [
  {
    path: '/',
    alias: '/layout',
    component: resolve => (require(["@/views/layout/index.vue"], resolve)),
    children: [
      {
        path: '/',
        alias: '/index',
        component: resolve => (require(["@/views/Home/Home.vue"], resolve)),
      },
      // {
      //   path: '/a',
      //   alias: '/a',
      //   component: resolve => (require(["@/views/Home/a.vue"], resolve)),
      // },

    ]
  },
  {
    path: '/layout2',
    alias: '/layout2',
    component: resolve => (require(["@/views/layout/index2.vue"], resolve)),
    children: [
      {
        path: '/resultsShow',
        alias: '/resultsShow',
        component: resolve => (require(["@/views/ResultsShow/index.vue"], resolve)),
      },
      {
        path: '/resultsShowD',
        alias: '/resultsShowD',
        component: resolve => (require(["@/views/ResultsShow/detail.vue"], resolve)),
      },
      {
        path: '/notice',
        alias: '/notice',
        component: resolve => (require(["@/views/Notice/index.vue"], resolve)),
      },
      {
        path: '/noticeD',
        alias: '/noticeD',
        component: resolve => (require(["@/views/Notice/detail.vue"], resolve)),
      },
     
      {
        path: '/event',
        alias: '/event',
        component: resolve => (require(["@/views/Event/index.vue"], resolve)),
      },
      {
        path: '/eventD',
        alias: '/eventD',
        component: resolve => (require(["@/views/Event/detail.vue"], resolve)),
      },
      {
        path: '/news',
        alias: '/news',
        component: resolve => (require(["@/views/News/index.vue"], resolve)),
      },
      {
        path: '/schedule',
        alias: '/schedule',
        component: resolve => (require(["@/views/Schedule/index.vue"], resolve)),
      },
      {
        path: '/activityGuide',
        alias: '/activityGuide',
        component: resolve => (require(["@/views/ActivityGuide/index.vue"], resolve)),
      },
      {
        path: '/workshopIndex',
        alias: '/workshopIndex',
        component: resolve => (require(["@/views/workshop/index.vue"], resolve)),
      },
       {
        path: '/appointment',
        alias: '/appointment',
        component: resolve => (require(["@/views/workshop/appointment.vue"], resolve)),
      },
       {
        path: '/myappointment',
        alias: '/myappointment',
        component: resolve => (require(["@/views/workshop/myappointment.vue"], resolve)),
      },
       {
        path: '/appointmentQrcode',
        alias: '/appointmentQrcode',
        component: resolve => (require(["@/views/workshop/appointmentQrcode.vue"], resolve)),
      },
      {
        path: '/strategy',
        alias: '/strategy',
        component: resolve => (require(["@/views/StrategyBox/index.vue"], resolve)),
      },
      {
        path: '/strategyD',
        alias: '/strategyD',
        component: resolve => (require(["@/views/StrategyBox/detail.vue"], resolve)),
      },
      {
        path: '/media',
        alias: '/media',
        component: resolve => (require(["@/views/media/index.vue"], resolve)),
      },
      {
        path: '/mediaD',
        alias: '/mediaD',
        component: resolve => (require(["@/views/media/detail.vue"], resolve)),
      },
      {
        path: '/enterprise',
        alias: '/enterprise',
        component: resolve => (require(["@/views/enterprise/index.vue"], resolve)),
      },
      {
        path: '/enterpriseD',
        alias: '/enterpriseD',
        component: resolve => (require(["@/views/enterprise/detail.vue"], resolve)),
      },
      {
        path: '/enterprisecpd',
        alias: '/enterprisecpd',
        component: resolve => (require(["@/views/enterprise/cpDetail.vue"], resolve)),
      },{
        path: '/qyzx',
        alias: '/qyzx',
        component: resolve => (require(["@/views/enterprise/qyzx.vue"], resolve)),
      },{
        path: '/sxjd',
        alias: '/sxjd',
        component: resolve => (require(["@/views/enterprise/sxjd.vue"], resolve)),
      },{
        path: '/kcDisplay',
        alias: '/kcDisplay',
        component: resolve => (require(["@/views/enterprise/kcDisplay.vue"], resolve)),
      },{
        path: '/certificate',
        alias: '/certificate',
        component: resolve => (require(["@/views/enterprise/certificate.vue"], resolve)),
      },
      {
        path: '/toolDownload',
        alias: '/toolDownload',
        component: resolve => (require(["@/views/ApplicationCenter/toolDownload.vue"], resolve)),
      },
      {
        path: '/tools',
        alias: '/tools',
        component: resolve => (require(["@/views/tools/index.vue"], resolve)),
      }
    ]
  }
]

export default Routers